export enum PixelType {
  Init = 'init',
  Submit = 'submit',
  Reg = 'registration',
}

export interface PixelConfig {
  trafficJunkyUrl: string;
  exoClickUrl: string;
}
